import { __decorate } from "tslib";
import { attr, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { classNames } from '@microsoft/fast-web-utilities';
import { foundationActionsMenuStyles as styles } from './actions-menu.styles';
import { singleOptionTemplate, menuTemplate, foundationActionsMenuTemplate as template, } from './actions-menu.template';
/**
 * @tagname %%prefix%%-actions-menu
 */
export class ActionsMenu extends FoundationElement {
    constructor() {
        super(...arguments);
        this.isVertical = false;
        this.addDefaultActions = true;
        this.autoCloseOnAction = true;
        this.name = 'Actions';
        this.open = false;
        this.hideDisabled = false;
        this.hideMenuSingleOption = false;
    }
    definitionChanged(oldValue, newValue) {
        var _a;
        this.actions = (_a = newValue === null || newValue === void 0 ? void 0 : newValue.actions) !== null && _a !== void 0 ? _a : [];
        delete this.definition.actions;
        if (newValue.buttonText) {
            this.name = newValue.buttonText;
            delete this.definition.customButtonText;
        }
        if (newValue.isVertical) {
            this.isVertical = newValue.isVertical;
            delete this.definition.isVertical;
        }
        if (newValue.buttonAppearance) {
            this.buttonAppearance = newValue.buttonAppearance;
            delete this.definition.buttonAppearance;
        }
        if (newValue.hideMenuSingleOption) {
            this.hideMenuSingleOption = newValue.hideMenuSingleOption;
            delete this.definition.hideMenuSingleOption;
        }
    }
    openChanged() {
        this.classNames = classNames(['visible', this.open], ['hidden', !this.open]);
    }
    toggleActionsMenuVisibility() {
        this.open = !this.open;
    }
    onActionMenuItemClick(callback) {
        if (this.autoCloseOnAction)
            this.open = false;
        callback(this.rowData);
    }
    get allActions() {
        var _a;
        const defaultActions = [
            {
                name: '✖',
                callback: () => (this.open = false),
            },
        ];
        return this.addDefaultActions ? [...((_a = this.actions) !== null && _a !== void 0 ? _a : []), ...defaultActions] : this.actions;
    }
    get rowData() {
        if (!this.definition)
            return;
        const { node, data } = this.definition;
        return (node === null || node === void 0 ? void 0 : node.data) || data;
    }
    getLabel(name) {
        if (!this.rowData) {
            return '';
        }
        else if (typeof name === 'function') {
            return name(this.rowData);
        }
        return name;
    }
    getTemplate(prefix) {
        if (!this.hideMenuSingleOption) {
            return menuTemplate(prefix);
        }
        const enabledRows = this.actions.filter((action) => {
            if (!action.isDisabled) {
                return true;
            }
            return !action.isDisabled(this.rowData);
        });
        this.singleOption = null;
        if (enabledRows.length === 0) {
            return;
        }
        else if (enabledRows.length === 1) {
            this.singleOption = enabledRows[0];
            return singleOptionTemplate(prefix);
        }
        return menuTemplate(prefix);
    }
}
__decorate([
    observable
], ActionsMenu.prototype, "actions", void 0);
__decorate([
    attr({ attribute: 'is-vertical', mode: 'boolean' })
], ActionsMenu.prototype, "isVertical", void 0);
__decorate([
    attr({ attribute: 'add-default-actions', mode: 'boolean' })
], ActionsMenu.prototype, "addDefaultActions", void 0);
__decorate([
    attr({ attribute: 'auto-close-on-action', mode: 'boolean' })
], ActionsMenu.prototype, "autoCloseOnAction", void 0);
__decorate([
    observable
], ActionsMenu.prototype, "classNames", void 0);
__decorate([
    observable
], ActionsMenu.prototype, "definition", void 0);
__decorate([
    attr
], ActionsMenu.prototype, "name", void 0);
__decorate([
    attr({ attribute: 'open', mode: 'boolean' })
], ActionsMenu.prototype, "open", void 0);
__decorate([
    attr
], ActionsMenu.prototype, "buttonAppearance", void 0);
__decorate([
    attr({ attribute: 'hide-disabled', mode: 'boolean' })
], ActionsMenu.prototype, "hideDisabled", void 0);
__decorate([
    attr({ attribute: 'hide-menu-single-option', mode: 'boolean' })
], ActionsMenu.prototype, "hideMenuSingleOption", void 0);
__decorate([
    observable
], ActionsMenu.prototype, "singleOption", void 0);
/**
 * The Foundation Actions Menu
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-actions-menu\>
 */
export const foundationActionsMenu = ActionsMenu.compose({
    baseName: 'actions-menu',
    styles,
    template,
});
